import React from "react";
import "./SuccessStoriesNewsletter.css";

export default function SuccessStoriesNewsletter() {

  const successStories = [
    {
      name: "Deepak B.",
      role: "Data Scientist",
      package: "18 LPA",
      image: "/success/student-1.png",
      text: "Built strong Python, data analysis, machine learning, and project explanation confidence.",
    },
    {
      name: "Priya S.",
      role: "AI Developer",
      package: "22 LPA",
      image: "/success/student-2.png",
      text: "Prepared through AI projects, API integration, model usage, and interview practice.",
    },
    {
      name: "Rohit K.",
      role: "Machine Learning Engineer",
      package: "28 LPA",
      image: "/success/student-3.png",
      text: "Worked on ML models, feature engineering, deployment basics, and project portfolio.",
    },
    {
      name: "Sneha P.",
      role: "Deep Learning Developer",
      package: "32 LPA",
      image: "/success/student-4.png",
      text: "Focused on neural networks, computer vision, model training, and technical confidence.",
    },

    {
      name: "Aman V.",
      role: "Full Stack Developer",
      package: "16 LPA",
      image: "/success/student-5.png",
      text: "Built frontend, backend, database, authentication, and complete project deployment skills.",
    },
    {
      name: "Nehal R.",
      role: "Software Engineer",
      package: "20 LPA",
      image: "/success/student-6.png",
      text: "Prepared with coding discipline, software development mindset, debugging, and interviews.",
    },
    {
      name: "Kunal M.",
      role: "Python Backend Developer",
      package: "24 LPA",
      image: "/success/student-7.png",
      text: "Worked on Python APIs, FastAPI, databases, backend logic, and production-ready projects.",
    },
    {
      name: "Prasad D.",
      role: "React Developer",
      package: "15 LPA",
      image: "/success/student-8.png",
      text: "Improved UI development, React projects, API integration, and frontend portfolio strength.",
    },

    {
      name: "Rahul N.",
      role: "GenAI Engineer",
      package: "35 LPA",
      image: "/success/student-9.png",
      text: "Prepared with LLMs, prompt engineering, RAG basics, AI tools, and project building.",
    },
    {
      name: "Ashwini T.",
      role: "MLOps Engineer",
      package: "45 LPA",
      image: "/success/student-10.png",
      text: "Focused on model deployment, Docker, APIs, monitoring mindset, and AI system workflow.",
    },
    {
      name: "Spruha J.",
      role: "AI Product Engineer",
      package: "48 LPA",
      image: "/success/student-11.png",
      text: "Built product-thinking skills across AI, software, user problems, and practical implementation.",
    },
    {
      name: "Anish C.",
      role: "AI Research Engineer",
      package: "55 LPA",
      image: "/success/student-12.png",
      text: "Worked on research direction, experimentation, technical writing, and advanced AI preparation.",
    },
  ];



  const newspaperImages = [
    {
      image: "/newsletter/news-1.jpg",
      title: "शिक्षणाचा बदलता चेहरा आणि जागतिक संधी",
      type: "Marathi Article",
      shape: "wide",
    },
    {

      image: "/newsletter/news-3.jpg",
      title: "महाराष्ट्राच्या मुलीला ४५ लाखांचे सॅलरी पॅकेज",
      type: "Success Story",
      shape: "wide",
    },
    {
      image: "/newsletter/news-3.webp",
      title: "सॉफ्टवेअर कंपन्या स्वतःच देतायत AI प्रशिक्षण",
      type: "Technology Update",
      shape: "wide",
    },
    {
      image: "/newsletter/news-4.jpg",
      title: "AI क्षेत्रात तरुणांना उत्तम मार्गदर्शन",
      type: "AI Career News",
      shape: "wide",
    },
    {
      image: "/newsletter/news-5.jpg",
      title: "मोठ्या पगाराची आमिषे आणि फसलेली तरुणाई",
      type: "Awareness Article",
      shape: "wide",
    },
    {
      image: "/newsletter/news-6.jpg",
      title: "मराठमोळ्या अश्विनीचा अमेरिकेत वाजला डंका",
      type: "Student Success Feature",
      shape: "wide",
    },
    {


      image: "/newsletter/news-7.jpg",
      title: "After Graduation, What Next?",
      type: "English Article",
      shape: "square",
    },
    {
      image: "/newsletter/news-8.jpg",
      title: "पदवी नंतरचा प्रश्न: आता पुढे काय?",
      type: "Career Guidance",
      shape: "square",
    },
  ];

  const wideNewspapers = newspaperImages.filter((item) => item.shape === "wide");
  const squareNewspapers = newspaperImages.filter((item) => item.shape === "square");

  return (
    <main className="proof-page">
      {/* SUCCESS STORIES */}
      <section className="proof-section proof-hero">
        <div className="proof-heading">
          <p className="section-kicker">SUCCESS STORIES</p>
          <h1>Students who started with discipline and built career direction.</h1>

        </div>

        <div className="success-story-grid">
          {successStories.map((story) => (
            <div className="success-story-card" key={story.name}>
              <div className="success-photo">
                <img src={story.image} alt={story.name} />
              </div>

              <div className="success-content">
                <h3>{story.name}</h3>
                <span>{story.role}</span>

                <div className="success-package">{story.package}</div>

                <p>{story.text}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="success-note">Please Note :

          These are only a few selected student journeys. Many more students are

          learning with discipline, growing, building projects, preparing for interviews, and moving

          closer to strong technology careers with StudyAIPlacement. Your journey can be

          the next one.

        </p>
      </section>

      {/* GOVERNMENT / STARTUP INDIA */}
      <section className="proof-section">
        <div className="proof-heading">
          <p className="section-kicker">GOVERNMENT OF INDIA RECOGNITION</p>


        </div>

        <div className="certificate-box">
          <div className="certificate-badge-row">
            <span className="india-pill">🇮🇳 Government of India Recognition</span>
            <span className="chakra-mark">✺</span>
            <span className="india-pill green">Startup India Certified</span>
          </div>

          <div className="certificate-inner">
            <div className="certificate-image">
              <img
                src="/certificates/startup-india-certificate.jpg"
                alt="Startup India Certificate"
              />
            </div>

            <div className="certificate-content">
              <p className="section-kicker">STARTUP INDIA CERTIFICATION</p>
              <h3>Recognised under Startup India initiative.</h3>
              <p>
                StudyAIPlacement is recognised under the Startup India initiative, adding
                official credibility to our mission of building serious AI and technology
                career preparation for students.
              </p>


            </div>
          </div>
        </div>
      </section>

      {/* NEWSPAPER / NEWSLETTER */}
      <section className="proof-section">
        <div className="proof-heading">
          <p className="section-kicker">NEWSLETTER & MEDIA</p>
          <h2>Newspaper features, updates, and announcements.</h2>

        </div>



        <div className="newspaper-wide-grid">
          {wideNewspapers.map((item, index) => (
            <div className="newspaper-card newspaper-card-wide" key={item.image}>
              <div className="newspaper-image newspaper-image-wide">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="newspaper-content">
                <span>{item.type}</span>
                <h3>{item.title}</h3>
                <small>Media Update 0{index + 1}</small>
              </div>
            </div>
          ))}
        </div>

        <div className="newspaper-square-grid">
          {squareNewspapers.map((item, index) => (
            <div className="newspaper-card newspaper-card-square" key={item.image}>
              <div className="newspaper-image newspaper-image-square">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="newspaper-content">
                <span>{item.type}</span>
                <h3>{item.title}</h3>
                <small>Media Update 0{wideNewspapers.length + index + 1}</small>
              </div>
            </div>
          ))}
        </div>
      </section>

    </main>
  );
}